import type { FaireProductEntity } from "../../entity_types/product";

export const p_eafm6gjryf: FaireProductEntity = {
  token: "p_eafm6gjryf",
  type: "product",
  name: "Belt waist print V-neck simple single-breasted long dress",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Lily Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/b832a71d6f5a30f63b461031b4d4e03f79735e91aa2274c14f3fcd44e5df15a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c923c96fef61464de1e72babdced401cf09fb864cb7d38fba4716a080365c1b6.jpeg",
    "https://cdn.faire.com/fastly/c46c69554a02c2ec9b2ddf54c2684318cac3a115a44d67cdd2cf09ef57bbd41e.jpeg",
    "https://cdn.faire.com/fastly/b80103d8f5cc1c835318b9b7fac67b7b4f56c5d773ae8b32ba1a205c72df6f77.jpeg",
    "https://cdn.faire.com/fastly/2fbe982c65c948b5517ffa066e9798cda90371ee53f13aa51b74b97778630ebb.jpeg",
    "https://cdn.faire.com/fastly/3b531b0edecdeadcd3b10c7c87e85ce6000b37dd41e9dc887ea6f8b97a32107f.jpeg",
  ],
  priceDollars: 15.75,
  description:
    "Women patterned button down long length dress\n95% polyester, 5% spandex\nSize S-M-L-XL-XXL\nOur product size standards are different, please check the size information before placing an order. Made in China\n\nWomen blazer, bathing suits, crochet cardigan, cable knit sweater, wholesale t shirts, beach cover ups, ruffle dress, eyelet blouse, puff sleeve top, floral dress, women t shirt, women shorts, women dress, women pants, bohemian, boho, western sweater, fall top, fall t shirt, fall dress, maxi dress, fall tee, women fall top, fall blouse, FW apparel, 2023 women apparel, July best, western, western apparel",
  tags: [],
  msrpDollars: 31.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:33.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
